var exports = {
  "w": "x804f0401--2551dc--header",
  "D": "x804f0401--2551dc--title",
};

module.exports = exports;
